import {
  SET_FILTERED_INVOICE_CNS,
  SET_INVOICE_NUMBER_CONSIGNMENT,
  SET_INVOICE_NUMBER_DATA,
  SET_INVOICE_NUMBER_LOADER,
  SET_INVOICE_NUMBER_POD_LIST,
  SET_INVOICE_REQUEST_LOADER,
  SET_SELECTED_INVOICE_CN_KEYS,
  SET_UPLOAD_FILE_LOADER,
  SET_PIECE_LEVEL_ACTIONS,
  SET_EVENT_TIMESTAMP,
} from 'src/common/actions/constants';

const defaultState = {
  loader: false,
  consignments: [],
  filteredConsignments: [],
  podList: [],
  searchLoading: false,
  dropdownNumberList: [],
  invoiceNumber: null,
  uploadLoading: false,
  selectedRowKeys: [],
  searchType: 'reference_number',
  tripType: 'trip',
  pieceLevelActions: {},
  eventTimestamp: {
    date: null,
    time: null,
  },
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case SET_SELECTED_INVOICE_CN_KEYS:
      return {
        ...state,
        selectedRowKeys: data,
      };
    case SET_INVOICE_REQUEST_LOADER: {
      return {
        ...state,
        loader: data,
      };
    }
    case SET_INVOICE_NUMBER_CONSIGNMENT: {
      return {
        ...state,
        consignments: data.consignments,
        filteredConsignments: data.consignments,
        selectedRowKeys: [],
        podList: data.podList ?? [],
        invoiceNumber: data.invoiceNumber,
        searchType: data.searchType,
      };
    }
    case SET_FILTERED_INVOICE_CNS: {
      return {
        ...state,
        filteredConsignments: data,
      };
    }

    case SET_INVOICE_NUMBER_POD_LIST: {
      return {
        ...state,
        podList: data,
        uploadLoading: false,
      };
    }

    case SET_INVOICE_NUMBER_LOADER: {
      return {
        ...state,
        searchLoading: data,
      };
    }

    case SET_INVOICE_NUMBER_DATA: {
      return {
        ...state,
        dropdownNumberList: data,
        searchLoading: false,
      };
    }

    case SET_UPLOAD_FILE_LOADER: {
      return {
        ...state,
        uploadLoading: data,
      };
    }

    case SET_PIECE_LEVEL_ACTIONS: {
      return {
        ...state,
        pieceLevelActions: data,
      };
    }

    case SET_EVENT_TIMESTAMP: {
      return {
        ...state,
        eventTimestamp: {
          ...state.eventTimestamp,
          ...data,
        },
      };
    }

    default:
      return state;
  }
};
